import script from "./ModalQrReserva.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalQrReserva.vue?vue&type=script&setup=true&lang=js"

import "./ModalQrReserva.vue?vue&type=style&index=0&id=641e499b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-641e499b"]])

export default __exports__